import set from 'lodash.set'
import React from 'react'

import { updateEventFeed } from '../../../services/data-explorer'
import { useRequestConfig } from '_hooks'
import { useEventFeedsContext } from '../../pages/event-feeds/context/index.jsx'
import LookbackSelect from '_components/lookback-select/index.jsx'

const LookbackSelectStored = ({ className, style, visualizationsPath, vertical, label }) => {
  const { id, data, dispatch, ACTIONS } = useEventFeedsContext()
  const { lookback } = useRequestConfig(visualizationsPath)

  const persistLookback = (value) => {
    const newValue = { ...data?.visualizations }

    set(newValue, visualizationsPath + '.lookback', value)

    const newData = { ...data, visualizations: newValue }
    updateEventFeed(id, newData)
    dispatch({ type: ACTIONS.SET_DATA, payload: newData })
  }

  return (
    <If condition={data?._id || id === 'discovery'}>
      <LookbackSelect
        className={className}
        style={style}
        lookback={lookback}
        vertical={vertical}
        label={label}
        onLookbackChange={(periodValue) => persistLookback(periodValue)}
      />
    </If>
  )
}

export default LookbackSelectStored
